import { createSlice } from "@reduxjs/toolkit";
import {
  toGetAppointementSlot,
  toGetBranches,
  toGetMyAppointments,
  toGetMyInvoices,
} from "../actions/appointments.actions";

const initialState = {
  slots: {
    list: [],
    status: "",
  } as any,
  branches: {
    list: [],
    status: "idle",
  } as any,
  myAppointments: {
    list: [],
    status: "idle",
  } as any,
  myInvoices: {
    list: [],
    status: "idle",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const appointmentSlice = createSlice({
  name: "appointments",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetAppointementSlot.pending, (state) => {
      state.slots = { list: [], status: "idle" };
    });
    builder.addCase(toGetAppointementSlot.fulfilled, (state, action) => {
      state.slots = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetAppointementSlot.rejected, (state, action) => {
      state.slots = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetBranches.pending, (state) => {
      state.branches = { list: [], status: "idle" };
    });
    builder.addCase(toGetBranches.fulfilled, (state, action) => {
      state.branches = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetBranches.rejected, (state, action) => {
      state.branches = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetMyAppointments.pending, (state) => {
      state.myAppointments = {
        list: state.myAppointments?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetMyAppointments.fulfilled, (state, action) => {
      state.myAppointments = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetMyAppointments.rejected, (state, action) => {
      state.myAppointments = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetMyInvoices.pending, (state) => {
      state.myInvoices = {
        list: state.myInvoices?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetMyInvoices.fulfilled, (state, action) => {
      state.myInvoices = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetMyInvoices.rejected, (state, action) => {
      state.myInvoices = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default appointmentSlice.reducer;
